// Reproduces the "movix" wordmark with the orange "o" highlight.
// Variants: 'light' (white text on dark bg) and 'dark' (black text on light bg).
export default function MovixLogo({ variant = "light", showTagline = true, size = "md" }) {
  const isLight = variant === "light";
  const sizes = {
    sm: { text: "text-xl", tag: "text-[8px]", track: "tracking-[0.25em]" },
    md: { text: "text-3xl", tag: "text-[10px]", track: "tracking-[0.32em]" },
    lg: { text: "text-5xl", tag: "text-xs", track: "tracking-[0.4em]" },
    xl: { text: "text-7xl", tag: "text-sm", track: "tracking-[0.45em]" },
  };
  const s = sizes[size] || sizes.md;
  const baseColor = isLight ? "text-white" : "text-zinc-900";
  return (
    <div className="inline-flex flex-col items-center leading-none">
      <div className={`font-display font-black ${s.text} ${baseColor} tracking-tight lowercase select-none`}>
        m<span className="text-[#F5A623]">o</span>vix
      </div>
      {showTagline && (
        <div className={`${s.tag} ${s.track} font-mono font-semibold mt-1 ${isLight ? "text-white/70" : "text-zinc-600"}`}>
          CAR&nbsp;RENTAL
        </div>
      )}
    </div>
  );
}
